import React from 'react';
import { Typography } from '@mui/material';

import { StepPanelHeader } from '../../../../../components';
import startImage from '../../../../../assets/passing-star.png';
import LetsConnect from '../../../../letsConnect/LetsConnect';

const PositionClosedMessage = () => {
  return (
    <>
      <StepPanelHeader
        srcSetPng={startImage}
        alt="Star"
        data-testid="position-closed-title"
      >
        Thank you for recording a Video Interview with AgileEngine!
      </StepPanelHeader>
      <Typography variant="body1" data-testid="position-closed-text">
        Unfortunately, the position(s) you were considered for are no longer
        available. We greatly appreciate your efforts and will reach out if a
        suitable opportunity comes up again.
      </Typography>
      <Typography variant="body1" mb={0}>
        Best of luck in your search!
      </Typography>
      <LetsConnect justifyContent={{ xs: 'flex-start', sm: 'center' }} />
    </>
  );
};

export default PositionClosedMessage;
